(function () {
  'use strict';

  var FOCUSABLE =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var DEFAULT_LINE_PROPERTIES = { Type: 'Greeting card' };

  var DEFAULT_LABELS = {
    addToOrder: 'Add to order',
    confirmChanges: 'Confirm changes',
    confirmRemoval: 'Confirm removal',
    allRemoved: 'All cards removed',
    stageNote: 'Added when you press Add to Cart',
    editNote: 'Your cart updates when you confirm',
    noChanges: 'No changes yet',
    chooseOption: 'Choose an option'
  };

  var PALETTE = {
    birthday: '#FBE0A6',
    'thank you': '#DCEEDC',
    love: '#FBDCE1',
    congrats: '#DCE4F7',
    sympathy: '#EDE3F6',
    'just because': '#F2E7DA',
    wedding: '#EAF1F4'
  };
  var FALLBACK = ['#FBE0A6', '#DCEEDC', '#FBDCE1', '#DCE4F7', '#EDE3F6'];

  var data = null;
  var cards = [];
  var byId = Object.create(null);
  var byProduct = Object.create(null);
  var variantChoice = new Map();
  var filters = [];
  var activeFilter = '__all__';

  var selection = new Map();
  var pending = new Map();
  var cartQty = new Map();
  var mode = 'stage';
  var selectionTouched = false;

  var picker = null;
  var dialog = null;
  var lastFocused = null;
  var focusProductId = null;
  var busy = false;

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }
  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function label(key, replacements) {
    var str = (data.labels && data.labels[key]) || DEFAULT_LABELS[key] || '';
    Object.keys(replacements || {}).forEach(function (token) {
      str = str.replace('[' + token + ']', replacements[token]);
    });
    return str;
  }
  function lineProperties() {
    return (data && data.lineProperties) || DEFAULT_LINE_PROPERTIES;
  }
  function money(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: data.currency
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  }
  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function emit(name, detail) {
    document.dispatchEvent(new CustomEvent('gcard:' + name, { detail: detail || {}, bubbles: true }));
  }
  function artBg(item, index) {
    if (item.color) return item.color;
    var key = (item.occasion || '').toLowerCase();
    var seed = typeof index === 'number' ? index : item.index || 0;
    return PALETTE[key] || FALLBACK[seed % FALLBACK.length];
  }
  function totalOf(map) {
    var count = 0;
    map.forEach(function (qty) {
      count += qty;
    });
    return count;
  }
  function valueOf(map) {
    var sum = 0;
    map.forEach(function (qty, id) {
      if (byId[id]) sum += byId[id].price * qty;
    });
    return sum;
  }
  function baseline() {
    return mode === 'cart' ? cartQty : pending;
  }

  function init() {
    var source = document.getElementById('GreetingCardData');
    if (!source) return;
    try {
      data = JSON.parse(source.textContent);
    } catch (e) {
      return;
    }

    cards = data.cards || [];
    cards.forEach(function (card, index) {
      card.index = index;
      card.productId = card.productId || card.id;

      if (!card.variants || !card.variants.length) {
        card.variants = [
          {
            id: card.id,
            title: '',
            available: card.available !== false,
            price: card.price,
            priceFormatted: card.priceFormatted,
            image: card.image
          }
        ];
      }

      byProduct[card.productId] = card;

      card.variants.forEach(function (variant) {
        byId[variant.id] = {
          id: variant.id,
          productId: card.productId,
          title: card.title,
          variantTitle: card.hasVariants ? variant.title : '',
          price: variant.price,
          priceFormatted: variant.priceFormatted,
          available: variant.available,
          image: variant.image || card.image,
          color: card.color,
          occasion: card.occasion,
          index: index
        };
      });

      variantChoice.set(card.productId, defaultVariantId(card));
    });

    picker = document.getElementById('GreetingCardPicker');
    dialog = picker ? $('[data-gcard-dialog]', picker) : null;

    buildFilters();
    readCartLines(data.cartLines || []);
    renderRows();
    bind();
  }

  function defaultVariantId(card) {
    var available = card.variants.filter(function (variant) {
      return variant.available;
    })[0];
    return (available || card.variants[0]).id;
  }

  function currentVariantId(card) {
    var chosen = variantChoice.get(card.productId);
    var exists = card.variants.some(function (variant) {
      return variant.id === chosen;
    });
    return exists ? chosen : defaultVariantId(card);
  }

  function variantOf(card, id) {
    return (
      card.variants.filter(function (variant) {
        return variant.id === id;
      })[0] || card.variants[0]
    );
  }

  function buildFilters() {
    var order = String(data.filterOrder || '')
      .split(',')
      .map(function (item) {
        return item.trim();
      })
      .filter(Boolean);

    var present = [];
    cards.forEach(function (card) {
      (card.tags || []).forEach(function (tag) {
        if (tag.toLowerCase() === String(data.bestTag).toLowerCase()) return;
        if (present.indexOf(tag) === -1) present.push(tag);
      });
    });

    var ordered = [];
    order.forEach(function (wanted) {
      var match = present.find(function (tag) {
        return tag.toLowerCase() === wanted.toLowerCase();
      });
      if (match && ordered.indexOf(match) === -1) ordered.push(match);
    });
    present.forEach(function (tag) {
      if (ordered.indexOf(tag) === -1) ordered.push(tag);
    });

    filters = ordered;
  }

  function readCartLines(lines) {
    cartQty = new Map();
    (lines || []).forEach(function (line) {
      var id = line.variant_id || line.id;
      if (byId[id]) cartQty.set(id, (cartQty.get(id) || 0) + line.quantity);
    });
  }

  function fetchCart() {
    return fetch(rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        return res.json();
      })
      .then(function (cart) {
        readCartLines(cart.items || []);
        return cart;
      })
      .catch(function () {
        return null;
      });
  }

  function swatchLabel(title) {
    return String(title || '')
      .split(/[\s/]+/)
      .filter(Boolean)
      .slice(0, 2)
      .map(function (word) {
        return word.charAt(0).toUpperCase();
      })
      .join('');
  }

  function variantMarkup(card, variantId) {
    if (!card.hasVariants || card.variants.length < 2) return '';

    var swatches = card.variants
      .map(function (variant) {
        var chosen = selection.get(variant.id) || 0;
        var thumb = variant.thumb || variant.image || card.thumb || card.image;
        var media = thumb
          ? '<img src="' + esc(thumb) + '" alt="" loading="lazy">'
          : '<span class="gcard-swatch__initials">' + esc(swatchLabel(variant.title)) + '</span>';
        var aria = (card.optionName || label('chooseOption')) + ': ' + variant.title;
        if (!variant.available) aria += ' — ' + label('soldOut');

        return (
          '<button class="gcard-swatch' +
          (variant.id === variantId ? ' is-active' : '') +
          (variant.available ? '' : ' is-soldout') +
          '" type="button" data-gcard-swatch="' +
          card.productId +
          '" data-gcard-swatch-variant="' +
          variant.id +
          '" aria-pressed="' +
          (variant.id === variantId) +
          '" title="' +
          esc(variant.title) +
          '" aria-label="' +
          esc(aria) +
          '">' +
          '<span class="gcard-swatch__media">' +
          media +
          '</span>' +
          (chosen > 0 ? '<span class="gcard-swatch__qty" aria-hidden="true">' + chosen + '</span>' : '') +
          '</button>'
        );
      })
      .join('');

    return (
      '<div class="gcard-tile__options">' +
      '<span class="gcard-tile__option-name">' +
      esc(variantOf(card, variantId).title) +
      '</span>' +
      '<div class="gcard-tile__swatches" role="group" aria-label="' +
      esc((card.optionName || label('chooseOption')) + ' — ' + card.title) +
      '">' +
      swatches +
      '</div>' +
      '</div>'
    );
  }

  function tileMarkup(card) {
    var variantId = currentVariantId(card);
    var variant = variantOf(card, variantId);
    var qty = selection.get(variantId) || 0;
    var image = variant.image || card.image;
    var priceText = variant.priceFormatted || card.priceFormatted;

    var art = image
      ? '<img src="' + esc(image) + '" alt="' + esc(card.title) + '" loading="lazy">'
      : '<span class="gcard-tile__ph">' + esc(card.title) + '</span>';

    var control;
    if (!variant.available) {
      control = '<button class="gcard-tile__add" type="button" disabled>' + esc(label('soldOut')) + '</button>';
    } else if (qty > 0) {
      control =
        '<button class="gcard-tile__added" type="button" data-gcard-inc="' +
        variantId +
        '" aria-label="' +
        esc(label('increase', { title: card.title })) +
        '">' +
        '<svg width="11" height="9" viewBox="0 0 12 10" fill="none" aria-hidden="true"><path d="M1 5l3.2 3.2L11 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        qty +
        '</button>';
    } else {
      control =
        '<button class="gcard-tile__add" type="button" data-gcard-add="' +
        variantId +
        '" aria-label="' +
        esc(label('addAria', { title: card.title, price: priceText })) +
        '">' +
        esc(label('add')) +
        '</button>';
    }

    return (
      '<li class="gcard-tile' +
      (qty > 0 ? ' is-selected' : '') +
      (focusProductId === card.productId ? ' is-focus' : '') +
      '" data-gcard-tile="' +
      card.productId +
      '" data-gcard-variant="' +
      variantId +
      '" style="--gcard-art-bg: ' +
      esc(artBg(card, card.index)) +
      ';">' +
      '<button class="gcard-tile__art" type="button" data-gcard-toggle="' +
      variantId +
      '" aria-pressed="' +
      (qty > 0) +
      '" aria-label="' +
      esc(label('addAria', { title: card.title, price: priceText })) +
      '"' +
      (variant.available ? '' : ' disabled') +
      '>' +
      art +
      '<span class="gcard-tile__check" aria-hidden="true">' +
      '<svg width="12" height="10" viewBox="0 0 12 10" fill="none"><path d="M1 5l3.2 3.2L11 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</span>' +
      '</button>' +
      '<p class="gcard-tile__name">' +
      esc(card.title) +
      '</p>' +
      variantMarkup(card, variantId) +
      '<div class="gcard-tile__foot">' +
      '<span class="gcard-tile__price">' +
      esc(priceText) +
      '</span>' +
      control +
      '</div>' +
      '</li>'
    );
  }

  function renderPicker() {
    if (!picker) return;
    renderBest();
    renderChips();
    renderGrid();
    renderFooter();
  }

  function renderBest() {
    var section = $('[data-gcard-best]', picker);
    var list = $('[data-gcard-best-list]', picker);
    if (!section || !list) return;

    var best = cards.filter(function (card) {
      return card.best;
    });
    section.hidden = best.length === 0;
    list.innerHTML = best.map(tileMarkup).join('');
  }

  function renderChips() {
    var wrap = $('[data-gcard-chips]', picker);
    if (!wrap) return;

    var chips = [{ key: '__all__', name: label('all') || 'All' }].concat(
      filters.map(function (tag) {
        return { key: tag, name: tag };
      })
    );

    wrap.innerHTML = chips
      .map(function (chip) {
        return (
          '<button class="gcard-chip" type="button" data-gcard-chip="' +
          esc(chip.key) +
          '" aria-pressed="' +
          (activeFilter === chip.key) +
          '">' +
          esc(chip.name) +
          '</button>'
        );
      })
      .join('');
  }

  function visibleCards() {
    if (activeFilter === '__all__') return cards;
    return cards.filter(function (card) {
      return (card.tags || []).some(function (tag) {
        return tag.toLowerCase() === activeFilter.toLowerCase();
      });
    });
  }

  function renderGrid() {
    var grid = $('[data-gcard-grid]', picker);
    var count = $('[data-gcard-count]', picker);
    if (!grid) return;

    var list = visibleCards();
    if (count) count.textContent = '(' + list.length + ')';

    grid.innerHTML = list.length
      ? list.map(tileMarkup).join('')
      : '<li class="gcard-picker__empty">' + esc(label('emptyFilter')) + '</li>';
  }

  function refreshTiles(productId, origin) {
    var card = byProduct[productId];
    if (!card || !picker) return;

    var variantId = currentVariantId(card);

    $$('[data-gcard-tile="' + productId + '"]', picker).forEach(function (tile) {
      var hadFocus = origin && tile.contains(origin);
      var wrap = document.createElement('div');
      wrap.innerHTML = tileMarkup(card);
      var next = wrap.firstElementChild;
      if (!next) return;
      tile.replaceWith(next);
      if (hadFocus) {
        var swatch = next.querySelector('[data-gcard-swatch-variant="' + variantId + '"]');
        if (swatch) swatch.focus();
      }
    });

    renderFooter();
  }

  function changedIds() {
    var ids = new Set();
    selection.forEach(function (qty, id) {
      ids.add(id);
    });
    baseline().forEach(function (qty, id) {
      ids.add(id);
    });
    return ids;
  }

  function pendingChange() {
    var adding = 0;
    var removing = 0;
    var addValue = 0;
    var base = baseline();

    changedIds().forEach(function (id) {
      var target = selection.get(id) || 0;
      var current = base.get(id) || 0;
      if (target > current) {
        adding += target - current;
        if (byId[id]) addValue += byId[id].price * (target - current);
      } else if (target < current) {
        removing += current - target;
      }
    });

    return { adding: adding, removing: removing, addValue: addValue };
  }

  function renderFooter() {
    var summary = $('[data-gcard-summary]', picker);
    var note = $('[data-gcard-note]', picker) || $('.gcard-picker__summary-note', picker);
    var submit = $('[data-gcard-commit]', picker);
    var submitLabel = $('[data-gcard-submit-label]', picker);

    var count = totalOf(selection);
    var staging = mode !== 'cart';
    var change = pendingChange();
    var changed = change.adding > 0 || change.removing > 0;
    var addVerb = staging ? label('addToOrder') : label('addToCart');

    if (summary) {
      if (count === 0) {
        summary.textContent = baseline().size > 0 ? label('allRemoved') : label('noneSelected');
      } else {
        summary.textContent =
          count === 1 ? label('oneSelected') : label('manySelected', { count: count });
      }
    }

    if (note) {
      if (!changed && baseline().size > 0) {
        note.textContent = label('noChanges');
      } else {
        note.textContent = staging ? label('stageNote') : label('editNote');
      }
    }

    if (submitLabel) {
      if (!changed) {
        submitLabel.textContent = baseline().size > 0 ? label('confirmChanges') : addVerb;
      } else if (change.removing > 0 && change.adding === 0) {
        submitLabel.textContent = label('confirmRemoval');
      } else if (change.adding > 0 && change.removing === 0) {
        submitLabel.textContent = addVerb + ' · ' + money(change.addValue);
      } else {
        submitLabel.textContent = label('confirmChanges');
      }
    }

    if (submit) submit.disabled = !changed;
  }

  function stagedLines() {
    var lines = [];
    pending.forEach(function (qty, id) {
      if (byId[id] && qty > 0) lines.push({ card: byId[id], quantity: qty });
    });
    return lines;
  }

  function lineMarkup(line, index) {
    var card = line.card;
    var art = card.image
      ? '<img src="' + esc(card.image) + '" alt="' + esc(card.title) + '" loading="lazy">'
      : '';
    var meta = (card.variantTitle ? card.variantTitle : label('blankInside')) + ' · ' + card.priceFormatted;

    return (
      '<li class="gcard-line" data-gcard-line="' +
      card.id +
      '" style="--gcard-art-bg: ' +
      esc(artBg(card, index)) +
      ';">' +
      '<span class="gcard-line__art">' +
      art +
      '</span>' +
      '<span class="gcard-line__copy">' +
      '<span class="gcard-line__name">' +
      esc(card.title) +
      '</span>' +
      '<span class="gcard-line__meta">' +
      esc(meta) +
      '</span>' +
      '</span>' +
      '<span class="gcard-stepper">' +
      '<button type="button" data-gcard-line-dec="' +
      card.id +
      '" aria-label="' +
      esc(label('decrease', { title: card.title })) +
      '">&minus;</button>' +
      '<span class="gcard-stepper__value">' +
      line.quantity +
      '</span>' +
      '<button type="button" data-gcard-line-inc="' +
      card.id +
      '" aria-label="' +
      esc(label('increase', { title: card.title })) +
      '">+</button>' +
      '</span>' +
      '</li>'
    );
  }

  function renderRows() {
    var lines = stagedLines();

    $$('[data-gcard-row][data-gcard-placement="pdp"]').forEach(function (row) {
      var defaultState = $('[data-gcard-default]', row);
      var addedState = $('[data-gcard-added]', row);
      var checkboxes = $$('.gcard-row__checkbox', row);
      var total = $('[data-gcard-total]', row);
      var list = $('[data-gcard-lines]', row);

      checkboxes.forEach(function (checkbox) {
        checkbox.checked = lines.length > 0;
      });

      if (!lines.length) {
        if (defaultState) defaultState.hidden = false;
        if (addedState) addedState.hidden = true;
        return;
      }

      if (defaultState) defaultState.hidden = true;
      if (addedState) addedState.hidden = false;
      if (total) total.textContent = money(valueOf(pending));
      if (list) list.innerHTML = lines.map(lineMarkup).join('');
    });
  }

  function closeCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    if (typeof drawer.close === 'function') {
      try {
        drawer.close();
        return;
      } catch (e) {
        /* noop */
      }
    }

    var closeButton = drawer.querySelector(
      '[id^="CartDrawer-Close"], .cart-drawer__close, .drawer__close, [data-cart-close]'
    );
    if (closeButton) {
      closeButton.click();
      return;
    }

    drawer.classList.remove('active', 'animate', 'is-open', 'open');
    document.body.classList.remove('overflow-hidden');
  }

  function seedSelection() {
    var seed = new Map(baseline());
    if (mode === 'cart') {
      pending.forEach(function (qty, id) {
        seed.set(id, (cartQty.get(id) || 0) + qty);
      });
    }
    return seed;
  }

  function applyPopupCopy() {
    var row = document.querySelector('[data-gcard-row][data-gcard-placement="pdp"]');
    if (!row) return;

    var titleEl = $('#GreetingCardPickerTitle', picker);
    var subEl = $('.gcard-picker__sub', picker);

    if (row.dataset.gcardPopupTitle && titleEl) titleEl.textContent = row.dataset.gcardPopupTitle;
    if (row.dataset.gcardPopupSubtitle && subEl) subEl.textContent = row.dataset.gcardPopupSubtitle;
  }

  function open(source, focusId) {
    if (!picker) return;
    applyPopupCopy();

    var canStage = !!document.querySelector('[data-gcard-row][data-gcard-placement="pdp"]');
    mode = source === 'cart' || !canStage ? 'cart' : 'stage';
    if (source === 'cart') closeCartDrawer();

    lastFocused = document.activeElement;
    focusProductId = null;

    if (focusId) {
      var entry = byId[parseInt(focusId, 10)];
      if (entry) {
        focusProductId = entry.productId;
        variantChoice.set(entry.productId, entry.id);
      }
    }

    selection = seedSelection();
    selectionTouched = false;
    activeFilter = '__all__';

    renderPicker();
    picker.hidden = false;
    document.documentElement.classList.add('gcard-scroll-lock');

    requestAnimationFrame(function () {
      picker.classList.add('is-open');
      if (dialog) dialog.focus();
      if (focusProductId) {
        var tile = $('[data-gcard-tile="' + focusProductId + '"]', picker);
        if (tile) tile.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    });

    emit('open', { source: source, mode: mode, staged: totalOf(pending), cardsInCart: totalOf(cartQty) });

    if (mode === 'cart') {
      fetchCart().then(function () {
        if (!selectionTouched) selection = seedSelection();
        renderPicker();
      });
    }
  }

  function close() {
    if (!picker || picker.hidden) return;
    picker.classList.remove('is-open');
    focusProductId = null;

    window.setTimeout(function () {
      picker.hidden = true;
      document.documentElement.classList.remove('gcard-scroll-lock');
      if (lastFocused && document.contains(lastFocused)) lastFocused.focus();
      lastFocused = null;
    }, 240);
  }

  function setQty(id, qty) {
    id = parseInt(id, 10);
    var entry = byId[id];
    if (!entry || !entry.available) return;

    selectionTouched = true;
    if (qty > 0) {
      selection.set(id, qty);
    } else {
      selection.delete(id);
    }
    renderPicker();
    emit('select', { id: id, title: entry.title, variant: entry.variantTitle, quantity: qty });
  }

  function bump(id, delta) {
    id = parseInt(id, 10);
    setQty(id, (selection.get(id) || 0) + delta);
  }

  function setBusy(state) {
    busy = state;
    if (picker) picker.classList.toggle('is-busy', state);
  }

  function sectionIds() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.getSectionsToRender !== 'function') return [];
    return drawer.getSectionsToRender().map(function (section) {
      return section.id;
    });
  }

  function cartRequest(path, body) {
    var ids = sectionIds();
    if (ids.length) {
      body.sections = ids;
      body.sections_url = window.location.pathname;
    }

    return fetch(rootUrl() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json();
    });
  }

  function addToCart(items) {
    return cartRequest('cart/add.js', { items: items });
  }

  function updateCart(updates) {
    return cartRequest('cart/update.js', { updates: updates });
  }

  function syncAfterCart(response) {
    var drawer = document.querySelector('cart-drawer');
    var rendered = false;

    if (drawer && response && response.sections && typeof drawer.renderContents === 'function') {
      drawer.classList.remove('is-empty');
      drawer.renderContents(response);
      rendered = true;
    }

    return fetchCart().then(function () {
      renderRows();
      if (picker && !picker.hidden) renderPicker();
      if (!rendered) return refreshCartSections();
    });
  }

  function refreshCartSections() {
    var drawer = document.querySelector('cart-drawer');
    var ids =
      drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map(function (section) {
            return section.id;
          })
        : [];

    if (drawer && ids.length) {
      return fetch('/?sections=' + ids.join(','))
        .then(function (res) {
          return res.json();
        })
        .then(function (sections) {
          drawer.classList.remove('is-empty');
          drawer.renderContents({ sections: sections });
          renderRows();
        })
        .catch(function () {
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        });
    }

    document.dispatchEvent(new CustomEvent('cart:refresh'));
    return Promise.resolve();
  }

  function commitToCart() {
    var adds = [];
    var updates = {};
    var hasUpdates = false;

    changedIds().forEach(function (id) {
      var target = selection.get(id) || 0;
      var current = cartQty.get(id) || 0;
      if (target === current) return;

      if (current === 0) {
        adds.push({ id: id, quantity: target, properties: lineProperties() });
      } else {
        updates[id] = target;
        hasUpdates = true;
      }
    });

    setBusy(true);

    var chain = Promise.resolve();
    if (adds.length) {
      chain = chain.then(function () {
        return addToCart(adds);
      });
    }
    if (hasUpdates) {
      chain = chain.then(function () {
        return updateCart(updates);
      });
    }

    chain
      .then(function (response) {
        pending = new Map();
        return syncAfterCart(response);
      })
      .catch(function () {
        /* noop */
      })
      .then(function () {
        setBusy(false);
        close();
      });
  }

  function commit() {
    var change = pendingChange();
    if (change.adding === 0 && change.removing === 0) {
      close();
      return;
    }
    if (busy) return;

    emit('commit', { mode: mode, cards: totalOf(selection), value: valueOf(selection) });

    if (mode === 'cart') {
      commitToCart();
      return;
    }

    pending = new Map(selection);
    renderRows();
    close();
  }

  function clearCards() {
    if (!pending.size) return;
    emit('clear', { cards: totalOf(pending) });
    pending = new Map();
    renderRows();
  }

  function quickAdd(button) {
    if (busy) return;
    var id = parseInt(button.dataset.gcardQuickadd, 10);
    if (!id || !byId[id]) return;

    busy = true;
    button.setAttribute('disabled', 'disabled');
    button.classList.add('is-adding');
    emit('quickadd', { id: id, title: byId[id].title });

    addToCart([{ id: id, quantity: 1, properties: lineProperties() }])
      .then(function (response) {
        if (response && response.status) throw new Error(response.description || 'add failed');
        return syncAfterCart(response);
      })
      .catch(function () {
        /* noop */
      })
      .then(function () {
        busy = false;
        if (document.contains(button)) {
          button.removeAttribute('disabled');
          button.classList.remove('is-adding');
        }
      });
  }

  function changeLine(id, delta) {
    id = parseInt(id, 10);
    var next = Math.max(0, (pending.get(id) || 0) + delta);
    if (next === 0) {
      pending.delete(id);
    } else {
      pending.set(id, next);
    }
    renderRows();
  }

  function bindProductForm() {
    document.addEventListener(
      'submit',
      function (event) {
        if (!pending.size) return;

        var form = event.target;
        if (!form || !form.action || form.action.indexOf('/cart/add') === -1) return;

        var submitter = event.submitter;
        if (submitter && submitter.name !== 'add') return;

        event.preventDefault();
        event.stopImmediatePropagation();
        submitWithCards(form);
      },
      true
    );
  }

  function submitWithCards(form) {
    var formData = new FormData(form);
    var mainId = parseInt(formData.get('id'), 10);
    if (!mainId) return;

    var quantity = parseInt(formData.get('quantity'), 10) || 1;
    var main = { id: mainId, quantity: quantity };

    var properties = {};
    formData.forEach(function (value, key) {
      var match = key.match(/^properties\[(.+)\]$/);
      if (match && String(value).length) properties[match[1]] = value;
    });
    if (Object.keys(properties).length) main.properties = properties;
    if (formData.get('selling_plan')) main.selling_plan = formData.get('selling_plan');

    var items = [main];
    pending.forEach(function (qty, id) {
      items.push({ id: id, quantity: qty, properties: lineProperties() });
    });

    var button = form.querySelector('[name="add"]');
    var spinner = button ? button.querySelector('.loading-overlay__spinner') : null;
    if (button) button.setAttribute('disabled', 'disabled');
    if (spinner) spinner.classList.remove('hidden');

    emit('submit', { product: mainId, quantity: quantity, cards: totalOf(pending) });

    addToCart(items)
      .then(function (response) {
        if (response && response.status) throw new Error(response.description || 'add failed');
        pending = new Map();
        return syncAfterCart(response);
      })
      .catch(function () {
        syncAfterCart();
      })
      .then(function () {
        if (button) button.removeAttribute('disabled');
        if (spinner) spinner.classList.add('hidden');
      });
  }

  function bind() {
    document.addEventListener('click', function (event) {
      var clear = event.target.closest('[data-gcard-clear]');
      if (clear) {
        event.preventDefault();
        clearCards();
        return;
      }

      var quick = event.target.closest('[data-gcard-quickadd]');
      if (quick) {
        event.preventDefault();
        quickAdd(quick);
        return;
      }

      var trigger = event.target.closest('[data-gcard-open]');
      if (trigger) {
        event.preventDefault();
        open(trigger.dataset.gcardSource || 'pdp', trigger.dataset.gcardFocus);
        if (trigger.matches('input[type="checkbox"]')) trigger.checked = pending.size > 0;
        return;
      }

      if (event.target.closest('[data-gcard-close]')) {
        close();
        return;
      }

      var swatch = event.target.closest('[data-gcard-swatch]');
      if (swatch) {
        event.preventDefault();
        var swatchProduct = parseInt(swatch.dataset.gcardSwatch, 10);
        var swatchVariant = parseInt(swatch.dataset.gcardSwatchVariant, 10);
        if (!swatchProduct || !swatchVariant) return;
        variantChoice.set(swatchProduct, swatchVariant);
        refreshTiles(swatchProduct, swatch);
        emit('variant', { productId: swatchProduct, variantId: swatchVariant });
        return;
      }

      var add = event.target.closest('[data-gcard-add]');
      if (add) {
        setQty(add.dataset.gcardAdd, 1);
        return;
      }

      var toggle = event.target.closest('[data-gcard-toggle]');
      if (toggle) {
        var toggleId = parseInt(toggle.dataset.gcardToggle, 10);
        setQty(toggleId, selection.get(toggleId) ? 0 : 1);
        return;
      }

      var inc = event.target.closest('[data-gcard-inc]');
      if (inc) {
        bump(inc.dataset.gcardInc, 1);
        return;
      }

      var dec = event.target.closest('[data-gcard-dec]');
      if (dec) {
        bump(dec.dataset.gcardDec, -1);
        return;
      }

      var lineInc = event.target.closest('[data-gcard-line-inc]');
      if (lineInc) {
        changeLine(lineInc.dataset.gcardLineInc, 1);
        return;
      }

      var lineDec = event.target.closest('[data-gcard-line-dec]');
      if (lineDec) {
        changeLine(lineDec.dataset.gcardLineDec, -1);
        return;
      }

      var chip = event.target.closest('[data-gcard-chip]');
      if (chip) {
        activeFilter = chip.dataset.gcardChip;
        renderChips();
        renderGrid();
        emit('filter', { filter: activeFilter });
        return;
      }

      if (event.target.closest('[data-gcard-commit]')) commit();
    });

    document.addEventListener('keydown', function (event) {
      if (!picker || picker.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        return;
      }
      if (event.key === 'Tab') trapFocus(event);
    });

    document.addEventListener('cart:refresh', function () {
      fetchCart();
    });

    bindProductForm();
    bindDrag();
  }

  function trapFocus(event) {
    var items = $$(FOCUSABLE, dialog).filter(function (el) {
      return el.offsetParent !== null;
    });
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function bindDrag() {
    if (!dialog) return;
    var startY = 0;
    var delta = 0;
    var dragging = false;

    function start(event) {
      if (window.innerWidth > 749) return;
      if (!event.target.closest('[data-gcard-drag]')) return;
      dragging = true;
      delta = 0;
      startY = event.touches[0].clientY;
      dialog.classList.add('is-dragging');
    }

    function move(event) {
      if (!dragging) return;
      delta = Math.max(0, event.touches[0].clientY - startY);
      dialog.style.transform = 'translateY(' + delta + 'px)';
    }

    function end() {
      if (!dragging) return;
      dragging = false;
      dialog.classList.remove('is-dragging');
      dialog.style.transform = '';
      if (delta > 100) close();
    }

    dialog.addEventListener('touchstart', start, { passive: true });
    dialog.addEventListener('touchmove', move, { passive: true });
    dialog.addEventListener('touchend', end, { passive: true });
    dialog.addEventListener('touchcancel', end, { passive: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();